module.exports = __webpack_public_path__ + "img/united-kingdom.6f78d5f0.svg";